/*eslint-disable*/
import React from "react";
// react plugin for creating charts
import ChartistGraph from "react-chartist";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons
import Timeline from "@material-ui/icons/Timeline";

// core components
import Heading from "components/Heading/Heading.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import Folder from "@material-ui/icons/Folder";
import DateRange from "@material-ui/icons/DateRange";
const _ = require("lodash");

import styles from "assets/jss/material-dashboard-pro-react/views/chartsStyle.js";

const useStyles = makeStyles(styles);

export default function Stats(props) {
  const classes = useStyles();

  const projectsDb = props.projects;
  const studiesDb = props.studies;

  let projectPubs = [];
  projectsDb.map((project) => {
    project.pmids.map((pmid) => {
      projectPubs.push(pmid);
    });
  });

  // const projectStudies = studiesDb.filter((study) => {
  //   return projectPubs.includes(study.uid);
  // });

  const dateArrays = studiesDb.map((study) => {
    return study.date;
  });

  //const dateSelections = ["2010, 2011, 2012, 2013, 2014", "2021"];

  const firstPublicationYear = 2010;
  const currentYear = new Date().getFullYear();
  const dateSelections = Array.from(
    { length: currentYear - firstPublicationYear + 1 },
    (_, index) => index + firstPublicationYear
  );

  const getDateCount = function (dateSelection) {
    return dateArrays.filter((date) => date.includes(dateSelection)).length;
  };

  const getDateArrayCount = dateSelections.map((dateSelection) => {
    return { [dateSelection]: getDateCount(dateSelection) };
  });

  const years = getDateArrayCount.map((dateSelection) => {
    return Object.keys(dateSelection);
  });

  const counts = getDateArrayCount.map((dateSelection) => {
    return Object.values(dateSelection);
  });

  const countsAlt = counts.toString();

  const countsAltTwo = [countsAlt.split(",").map(Number)];

  const maxCount = Math.max(...counts);

  const sumCount = _.sum(...countsAltTwo);

  const colouredLineChart = {
    data: {
      labels: years,
      series: countsAltTwo,
    },
    options: {
      lineSmooth: Chartist.Interpolation.cardinal({
        tension: 10,
      }),
      axisY: {
        showGrid: true,
        offset: 40,
      },
      axisX: {
        showGrid: false,
      },
      low: 0,
      high: maxCount,
      showPoint: true,
      height: "300px",
    },
    animation: {
      draw: function (data) {
        if (data.type === "line" || data.type === "area") {
          data.element.animate({
            d: {
              begin: 600,
              dur: 700,
              from: data.path
                .clone()
                .scale(1, 0)
                .translate(0, data.chartRect.height())
                .stringify(),
              to: data.path.clone().stringify(),
              easing: Chartist.Svg.Easing.easeOutQuint,
            },
          });
        } else if (data.type === "point") {
          data.element.animate({
            opacity: {
              begin: (data.index + 1) * 80,
              dur: 500,
              from: 0,
              to: 1,
              easing: "ease",
            },
          });
        }
      },
    },
  };

  return (
    <div>
      <Heading textAlign="center" title="Research Stats" />

      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="info" icon>
              <CardIcon color="info">
                <Timeline />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>
                Number of PREVENT Publications Per Year
              </h4>
            </CardHeader>
            <CardBody>
              <ChartistGraph
                data={colouredLineChart.data}
                type="Line"
                options={colouredLineChart.options}
                listener={colouredLineChart.animation}
              />
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={6} md={6} lg={6}>
          <Card>
            <CardHeader color="success" stats icon>
              <CardIcon color="success">
                <Folder />
              </CardIcon>
              <p className={classes.cardCategory}>Total PREVENT Publications</p>
              <h3 className={classes.cardTitle}>{sumCount}</h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <DateRange />
                Since 2010
              </div>
            </CardFooter>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}


